import { useMutation } from "@tanstack/react-query";
import { appointmentService } from "..";
import { UpdateMerchantServiceCategoryCommand } from "@/models/club";

function useUpdateMerchantServiceCategory() {
  return useMutation({
    mutationFn: (command: UpdateMerchantServiceCategoryCommand) => {
      return appointmentService.editMerchantServicesCategory(command);
    },
  });
}

export default useUpdateMerchantServiceCategory;
